import { render, staticRenderFns } from "./ImobiliariaPreCadastrada.vue?vue&type=template&id=45daafe4&"
import script from "./ImobiliariaPreCadastrada.vue?vue&type=script&lang=js&"
export * from "./ImobiliariaPreCadastrada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports